import { Actor, CollisionType, SpriteSheet, Animation } from "excalibur";
import { Config } from "../config";
import { Resources } from "../Resources";
import { inventoryState } from "../state/stateManager";

export default class BottlingAnimation extends Actor {
  constructor() {
    super({
      x: 128,
      y: 48,
      radius: 5,
      collisionType: CollisionType.Fixed,
      name: "bottlerContainer",
    });
    this.haveFilled = false;
  }
  doAnim(anim) {
    console.log("mite: doAnim: ", anim);
    this.anim = anim;
    this.playingAnim = true;
  }
  onInitialize() {
    const bottlingSprites = SpriteSheet.fromImageSource({
      image: Resources.BottlingAnimation,
      grid: {
        spriteWidth: 32,
        spriteHeight: 64,
        rows: 1,
        columns: 15,
      },
    });
    const stopped = bottlingSprites.getSprite(0, 0);
    this.graphics.add("stopped", stopped);
    const filled = bottlingSprites.getSprite(14, 0);
    this.graphics.add("filled", filled);
    this.bottle = new Animation({
      frames: [
        {
          graphic: bottlingSprites.getSprite(0, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(1, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(2, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(3, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(4, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(5, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(6, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(7, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(8, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(9, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(10, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(11, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(12, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(13, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: bottlingSprites.getSprite(14, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("bottle", this.bottle);

    this.bottle &&
      this.bottle.events.on("loop", () => {
        console.log("ended anim, should stop");
        this.playingAnim = false;
        this.haveFilled = true;
        this.graphics.use("filled");
      });
  }
  onPostUpdate() {
    if (this.playingAnim) {
      this.graphics.use(this.anim);
    } else {
      if (!this.haveFilled) {
        this.graphics.use("stopped");
      } else {
        this.graphics.use("filled");
      }
    }
  }
}
